import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DoctorsService} from '../../../_services/doctors.service';
import {MatrixSpecialty} from '../../../_models/PSP/matrix-doctor-specialty';
import {AllMatrixSpecialtiesResponse} from '../../../_models/PSP/matrix-specialties/all-matrix-specialties-response';

@Component({
  selector: 'app-doctor-specialty',
  templateUrl: './doctor-specialty.component.html',
  styleUrls: ['./doctor-specialty.component.scss']
})
export class DoctorSpecialtyComponent implements OnInit {
  selectedSpecialtyId: number = null;
  specialties: MatrixSpecialty[] = [];

  @Output() specialtyChanged: EventEmitter<string> = new EventEmitter();
  @Input() companyId: number = null;

  constructor(private doctorsService: DoctorsService) { }

  ngOnInit(): void {
    this.readSpecialties();
  }

  modelChangeFn(event: any): void {
    this.onTouched();
    this.onChanged();

    this.specialtyChanged.emit(event);
  }

  onChanged = () => {};

  onTouched = () => {};

  readSpecialties(): void {
    if (!!localStorage.getItem('matrixDoctorSpecialties') && !!localStorage.getItem('matrixDoctorSpecialtiesExpiration')) {
      this.specialties = JSON.parse(localStorage.getItem('matrixDoctorSpecialties'));

      if (new Date(localStorage.getItem('matrixDoctorSpecialties')).getTime() < Date.now()) {
        localStorage.removeItem('matrixDoctorSpecialtiesExpiration');
      }
    } else {
      this.doctorsService
        .getMatrixDoctorsSpecialties()
        .subscribe((response: AllMatrixSpecialtiesResponse) => {
          this.specialties = response.data.specialties;

          this.updateSpecialtiesCache();
          this.updateSpecialtiesCacheExpiration(24);
        });
    }
  }

  private updateSpecialtiesCacheExpiration(hours: number): void {
    localStorage.setItem(
      'matrixDoctorSpecialtiesExpiration',
      (Date.now() + hours * 60 * 60 * 1000).toString()
    );
  }

  private updateSpecialtiesCache(): void {
    localStorage.setItem(
      'matrixDoctorSpecialties',
      JSON.stringify(this.specialties)
    );
  }
}
